import apiRequest from './index'

export default {
  path: '/v1/ping',
  get () {
    return apiRequest.get(this.path)
  }
}
